export const BenchMarkingHeaderConfig = [
  {
    label: "Competitor Name",
    id: "competitorName",
  },
  { label: "Application", id: "application" },

  {
    label: "Engine Model",
    id: "engineModel",
  },
  { label: "Engine Oil Grade", id: "engineOilGrade" },
  {
    label: "Fuel Consumption",
    id: "fuelConsumption",
  },
  {
    label: "Max Rating",
    id: "maxRating",
  },
  {
    label: "Core Features",
    id: "coreFeatures",
    render: (data) => {
      return <span>{data?.coreFeatures?.join(", ")}</span>;
    },
  },
  {
    label: "Max Torque",
    id: "maxTorque",
  },
  { label: "RPM Drop During Load", id: "rpmDropDuringLoad" },
  { label: "Size LWH", id: "sizeLWH" },
  { label: "Weight", id: "weight" },
];
